module.exports = __webpack_public_path__ + "img/file-spreadsheet.00a5aa7e.svg";